import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function SingleVerticalParking() {
  return (
    <div className="single-vertical-parent">
      <div className="vertical-title">
        <div className="text-900 font-bold text-7xl mb-4 text-center">
          FlexNet Parking: Smart Solutions for Efficient Parking Management
        </div>
        <div className="text-700 text-xl mb-6 text-center line-height-3">
          Revolutionize parking operations with real-time monitoring, automated
          systems, and secure 4G/5G connectivity.
        </div>
      </div>
      {/* Hero Section */}
      <div className="grid grid-nogutter surface-section text-800 ">
        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center">
          <section>
            <span className="block text-6xl font-bold mb-3">
              FlexNet Parking
            </span>
            <div className="text-6xl text-primary font-bold mb-3">
              Revolutionizing Operations with 5G Connectivity
            </div>
            <p className="mt-0 mb-4 text-700 line-height-3">
              Streamline parking management with FlexNet Parking. Our
              4G/5G-enabled solutions ensure efficient monitoring, optimized
              space utilization, enhanced security, and improved revenue streams
              for parking owners.
            </p>
            <button className="flex underline align-items-center mt-4">
              <Link to="/connectivity">Request Demo</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </section>
        </div>
        <div className="col-12 md:col-6 overflow-hidden">
          <img
            src="https://images.prismic.io//intuzwebsite/8551f8c1-a641-4973-bc7d-242e526dbb11_Banner.png?w=2400&q=80&auto=format,compress&fm=png8"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{ clipPath: "polygon(8% 0, 100% 0%, 100% 100%, 0 100%)" }}
          />
        </div>
      </div>

      {/* Key Benefits Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-900">Why </span>
          <span className="text-blue-600">FlexNet Parking?</span>
        </div>
        <div className="grid justify-center">
          {keyBenefits.map((benefit, index) => (
            <div key={index} className="col-12 md:col-4 mb-4 px-5">
              <span
                className="p-3 shadow-2 mb-3 inline-block surface-card"
                style={{ borderRadius: "10px" }}
              >
                <i className={`${benefit.icon} text-4xl text-blue-500`}></i>
              </span>
              <div className="text-900 text-xl mb-3 font-medium">
                {benefit.title}
              </div>
              <span className="text-700 line-height-3">{benefit.detail}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Use Cases Section */}

      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">FlexNet Parking </span>
        <span className="text-blue-600">Use Cases</span>
      </div>
      {useCases.map((useCase, index) => (
        <div
          key={index}
          className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center"
        >
          <div className="b-3 font-bold text-2xl mb-3">
            <span className="text-blue-600">Use Case</span>
            {useCase.title}
          </div>
          <div className="text-700 mb-6">{useCase.description}</div>
          <div className="grid">
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">Benefits</div>
              {useCase.benefits.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Devices/Technologies
              </div>
              {useCase.devices.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Applications
              </div>
              {useCase.applications.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <button className="flex underline align-items-center mt-4 vertical-market-link">
              <Link to="/marketplace">Request Access to Marketplace</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </div>
        </div>
      ))}

      {/* Case Studies Testimonias Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-blue-600"> Key Technical Features</span>
        </div>
        <div className="grid justify-center">
          <div className="text-900 text-xl mb-3 font-medium"></div>
          <div className="technical-specifications">
            <div className="text-700 line-height-3 technical-specifications-box text-xl">
              <ul className="list-disc pl-5 mt-3">
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Reliable 4G/5G connectivity with encrypted data transmission
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Edge computing for real-time processing
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Integration with existing parking management systems
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Scalable, modular architecture for diverse environments
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Low-latency communication for critical applications
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div className="surface-section text-center py-8">
        <div className="text-900 text-3xl font-bold mb-4">
          Ready to Transform Your Parking Operations?
        </div>

        <button className="p-button p-button-raised connectivity-request-demo-button p-3">
          <Link to="contact-page">Get in Touch for a Personalized Demo</Link>
        </button>
      </div>
    </div>
  );
}

const keyBenefits = [
  {
    title: "Real-Time Parking Space Monitoring and Dynamic Management",
    detail: "Optimize parking occupancy with real-time data and smart sensors.",
    icon: "pi pi-map",
  },
  {
    title: "Automated Payment and Smart Access Control Systems",
    detail: "Enhance user experience with seamless and secure transactions.",
    icon: "pi pi-credit-card",
  },
  {
    title: "Enhanced Security with AI-Powered Surveillance",
    detail:
      "Ensure safety with real-time video monitoring and AI-driven analytics.",
    icon: "pi pi-video",
  },
  {
    title: "Predictive Maintenance for Reduced Operational Downtime",
    detail: "Proactively maintain parking infrastructure to prevent failures.",
    icon: "pi pi-cog",
  },
  {
    title: "Dynamic Pricing Based on Real-Time Demand Analytics",
    detail: "Maximize revenue by adjusting pricing according to demand.",
    icon: "pi pi-chart-bar",
  },
  {
    title: "Reliable, Secure 4G/5G Connectivity for Remote and Urban Areas",
    detail: "Ensure stable network access for parking management systems.",
    icon: "pi pi-wifi",
  },
];

const useCases = [
  {
    title: " 1: Real-Time Dynamic Parking Management",
    description:
      "Enable real-time monitoring and management of parking spaces with IoT sensors and 4G/5G connectivity, optimizing occupancy rates.",
    benefits: [
      { title: "Maximize space utilization", icon: "pi pi-arrows-alt" },
      { title: "Reduce traffic congestion and emissions", icon: "pi pi-road" },
      {
        title: "Provide real-time availability updates to drivers",
        icon: "pi pi-bell",
      },
    ],
    devices: [
      { title: "IoT Sensors", icon: "pi pi-cloud" },
      { title: "4G/5G Gateways", icon: "pi pi-wifi" },
      { title: "Smart Displays", icon: "pi pi-desktop" },
    ],
    applications: [
      { title: "Urban Street Parking", icon: "pi pi-globe" },
      { title: "Mall Parking Lots", icon: "pi pi-building" },
      { title: "Corporate Campuses", icon: "pi pi-briefcase" },
    ],
  },
  {
    title:
      " 2: Seamless License Plate Recognition (LPR) & Smart Access Control",
    description:
      "Implement high-definition LPR cameras with fast, reliable 4G/5G connectivity for automated access and billing.",
    benefits: [
      { title: "Reduce entry/exit bottlenecks", icon: "pi pi-car" },
      {
        title: "Enhance security with automated verification",
        icon: "pi pi-lock",
      },
      {
        title: "Improve customer convenience with cashless systems",
        icon: "pi pi-credit-card",
      },
    ],
    devices: [
      { title: "LPR Cameras", icon: "pi pi-camera" },
      { title: "4G/5G Modems", icon: "pi pi-wifi" },
      { title: "Smart Barriers", icon: "pi pi-arrow-right" },
    ],
    applications: [
      { title: "Airports", icon: "pi pi-map " },
      { title: "Commercial Garages", icon: "pi pi-building" },
      { title: "Residential Complexes", icon: "pi pi-home" },
    ],
  },
  {
    title: " 3: Remote Monitoring & Predictive Maintenance",
    description:
      "Use 4G/5G to enable continuous health monitoring of parking infrastructure and predictive maintenance alerts.",
    benefits: [
      {
        title: "Reduce downtime with proactive issue detection",
        icon: "pi pi-cog",
      },
      { title: "Lower maintenance costs", icon: "pi pi-dollar" },
      { title: "Extend equipment lifespan", icon: "pi pi-clock" },
    ],
    devices: [
      { title: "Predictive Analytics Platforms", icon: "pi pi-chart-line" },
      { title: "IoT Sensors", icon: "pi pi-cloud" },
      { title: "Cloud Management Systems", icon: "pi pi-server" },
    ],
    applications: [
      { title: "Large Parking Facilities", icon: "pi pi-building" },
      { title: "Malls", icon: "pi pi-shopping-cart" },
      { title: "Corporate Lots", icon: "pi pi-briefcase" },
    ],
  },
  {
    title: " 4: Dynamic Pricing and Data Analytics",
    description:
      "Leverage real-time data to implement dynamic pricing strategies based on demand, location, and time.",
    benefits: [
      {
        title: "Optimize revenue through data-driven pricing models",
        icon: "pi pi-chart-bar",
      },
      {
        title: "Analyze occupancy trends for strategic decisions",
        icon: "pi pi-chart-pie",
      },
      {
        title: "Improve user satisfaction with flexible pricing",
        icon: "pi pi-dollar",
      },
    ],
    devices: [
      { title: "Data Analytics Platforms", icon: "pi pi-database" },
      { title: "Cloud-based Management Systems", icon: "pi pi-cloud" },
    ],
    applications: [
      { title: "Smart Cities", icon: "pi pi-globe" },
      { title: "Event Venues", icon: "pi pi-ticket" },
      { title: "Transportation Hubs", icon: "pi pi-directions  " },
    ],
  },
  {
    title: " 5: Enhanced Security & Safety Monitoring",
    description:
      "Deploy AI-powered surveillance systems with real-time video feeds and automated threat detection using 4G/5G connectivity.",
    benefits: [
      {
        title: "Rapid incident detection and response",
        icon: "pi pi-exclamation-triangle",
      },
      { title: "Improved customer and asset safety", icon: "pi pi-shield" },
      { title: "Compliance with security regulations", icon: "pi pi-check" },
    ],
    devices: [
      { title: "AI Cameras", icon: "pi pi-camera" },
      { title: "4G/5G Routers", icon: "pi pi-wifi" },
      { title: "Panic Alert Systems", icon: "pi pi-bell" },
    ],
    applications: [
      { title: "Underground Parking", icon: "pi pi-building" },
      { title: "Remote Lots", icon: "pi pi-map" },
      { title: "Public Spaces", icon: "pi pi-globe" },
    ],
  },
];
